module.exports = __webpack_public_path__ + "static/media/pink-rose.a1843a0b.png";